export const DEFAULT_BUSINESS_CASE_AWAITING_REPLY_MINIMUM_HOURS = 4;
